import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { cn } from "../lib/utils";
import { Button } from "./ui/button";
import {
  Field,
  FieldGroup,
  FieldLabel,
} from "./ui/field";
import { Input } from "./ui/input";

export function LoginForm({ className, ...props }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    console.log('Supabase signInWithPassword result:', { data, error });
    setLoading(false);
    if (error) {
      setError(error.message);
    } else if (data?.user) {
      // Option A: Fetch user profile from roles table using anon key (client)
      // You MUST enable RLS on the roles table with a policy like:
      //   create policy "Users can select their own role row" on roles for select to authenticated using ((select auth.uid()) = id);
      //   alter table roles enable row level security;
      let userProfile = null;
      let profileError = null;
      try {
        const { data: profile, error: err } = await supabase
          .from('Roles')
          .select('*')
          .eq('id', data.user.id)
          .single();
        userProfile = profile;
        profileError = err;
        if (profileError) {
          setError('Login succeeded but failed to fetch user profile: ' + profileError.message);
          return;
        }
        // Optional: Set user profile in context/state here if your app uses a global user store
        console.log('User profile from app_users table:', userProfile);
      } catch(e) {
        setError('Exception fetching user profile: ' + e.message);
        return;
      }
      // proceed to dashboard after successful profile fetch
      navigate("/dashboard");
    } else {
      setError("Unknown error: login did not produce a user.");
    }
  };



  return (
    <form className={cn("flex flex-col gap-6", className)} onSubmit={handleSubmit} { ...props }>
      <FieldGroup>
        <div className="flex flex-col items-center gap-1 text-center">
          <h1 className="text-2xl font-bold">Login</h1>
          <p className="text-muted-foreground text-sm text-balance">
            Enter your email below to login.
          </p>
        </div>
        {error && (
          <div className="text-red-500 text-sm text-center py-1">{error}</div>
        )}
        <Field>
          <FieldLabel htmlFor="email">Email</FieldLabel>
          <Input
            id="email"
            type="email"
            placeholder="m@example.com"
            required
            value={email}
            onChange={e => setEmail(e.target.value)}
            disabled={loading}
          />
        </Field>
        <Field>
           <div className="flex items-center">
            <FieldLabel htmlFor="password">Password</FieldLabel>
            <button
              type="button"
              className="ml-auto text-sm underline-offset-4 hover:underline bg-transparent border-none p-0 cursor-pointer"
              tabIndex={0}
              onClick={() => alert("Password reset coming soon")}
            >
              Forgot your password?
            </button>
          </div>
          <Input
            id="password"
            type="password"
            required
            value={password}
            onChange={e => setPassword(e.target.value)}
            disabled={loading}
          />
        </Field>
        <Field>
          <Button className="bg-blue-500 text-white" type="submit" disabled={loading}>{loading ? "Logging in..." : "Login"}</Button>
        </Field>
        {/* <Field>
          <FieldDescription className="text-center">
            Don&apos;t have an account?{" "}
            <button type="button" className="underline underline-offset-4 bg-transparent border-none p-0 cursor-pointer" onClick={() => alert('Signup flow coming soon')}>Sign up</button>
          </FieldDescription>
        </Field> */}
      </FieldGroup>
    </form>
  )
}

